
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Badkamercore_ProjectType, CrudAction } from '@/__generated__/globalTypes'

@Component
export default class ProductPackageUploadImportDialog extends Vue {
  @Prop() show!: boolean
  @Prop({ required: false, default: CrudAction.Create }) crudAction!: CrudAction
  @Prop({ required: false, default: () => [] }) existingImportNames!: string[]
  @Prop({ required: false }) productPackageToUpdateId!: string
  @Prop({ required: false }) productPackageToUpdateName!: string
  @Prop({ required: false }) propositionType!: Badkamercore_ProjectType

  MAX_FILE_SIZE = 100000000 //bytes (~100 MB)
  NAME_MAX_LENGTH = 50

  name = ''
  file?: File | null = null
  isUploading = false

  acceptedFileTypes = ['text/csv', 'application/vnd.ms-excel']

  @Watch('show')
  onVisibilityChange() {
    if (!this.show) {
      this.file = null
      this.name = ''
    } else {
      this.name = this.productPackageToUpdateName ?? ''
    }
  }

  rules = {
    maxsize: (value: string) =>
      value?.toString()?.length <= this.NAME_MAX_LENGTH || this.$t('productPackage.imports.validations.maxSize')
  }

  get isUploadForProductPackageUpdate() {
    return !!this.productPackageToUpdateId && !!this.productPackageToUpdateName
  }

  get nameErrors() {
    const result: string[] = []

    if (!this.name) return result

    if (this.existingImportNames.includes(this.name.replace(/[^a-zA-Z0-9]/g, ''))) {
      result.push(this.$t('global.dialogs.upload.errors.duplicateName').toString())
    }

    return result
  }

  get fileErrors() {
    const result: string[] = []

    if (!this.file) return result

    if (this.file.size > this.MAX_FILE_SIZE) {
      const maxSizeInMB = Math.floor(this.MAX_FILE_SIZE / 1024 / 1024)
      const message = this.$t('global.dialogs.upload.errors.maxFileSize')
        .toString()
        .replace('{MAX}', maxSizeInMB.toString())
      result.push(message)
    }

    if (!this.acceptedFileTypes.includes(this.file.type)) {
      result.push(this.$t('global.dialogs.upload.errors.invalidType').toString())
    }

    return result
  }

  uploadFile() {
    if (!this.file || this.fileErrors.length || this.isUploading) return
    this.isUploading = true

    // We need to get the propositionType from the route when this popup is opened from the RouteNames.PRODUCT_PACKAGE_IMPORTS route.
    const propositionType = this.$route.params?.propositionType ?? this.propositionType

    this.$fileApi
      .uploadFile(
        `/importProductPackage/${propositionType.replace('_', '')}/${this.name}/${this.crudAction}/${
          this.productPackageToUpdateId
        }`,
        this.file
      )
      .then(() => this.$emit('file-uploaded'))
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .catch((error: any) => {
        this.$emit('close')
        this.$store.dispatch('showErrorDialog', {
          Code: 'E4177',
          Message: error
        })
      })
      .finally(() => {
        this.isUploading = false
        this.name = ''
        this.file = null
      })
  }
}
